"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_POSITION = exports.FlippedPositions = exports.Positions = exports.BoundariesElements = exports.Directions = void 0;

var _FlippedPositions;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Directions = {
  Top: 'top',
  Right: 'right',
  Bottom: 'bottom',
  Left: 'left'
};
exports.Directions = Directions;
var BoundariesElements = {
  Viewport: 'viewport',
  Window: 'window',
  ScrollParent: 'scrollParent'
};
exports.BoundariesElements = BoundariesElements;
var Positions = {
  TopLeft: 'top-start',
  TopCenter: 'top',
  TopRight: 'top-end',
  RightTop: 'right-start',
  RightCenter: 'right',
  RightBottom: 'right-end',
  BottomLeft: 'bottom-start',
  BottomCenter: 'bottom',
  BottomRight: 'bottom-end',
  LeftTop: 'left-start',
  LeftCenter: 'left',
  LeftBottom: 'left-end'
};
exports.Positions = Positions;
var FlippedPositions = (_FlippedPositions = {}, _defineProperty(_FlippedPositions, Positions.TopLeft, Positions.BottomLeft), _defineProperty(_FlippedPositions, Positions.TopCenter, Positions.BottomCenter), _defineProperty(_FlippedPositions, Positions.TopRight, Positions.BottomRight), _defineProperty(_FlippedPositions, Positions.BottomLeft, Positions.TopLeft), _defineProperty(_FlippedPositions, Positions.BottomCenter, Positions.TopCenter), _defineProperty(_FlippedPositions, Positions.BottomRight, Positions.TopRight), _defineProperty(_FlippedPositions, Positions.RightTop, Positions.LeftTop), _defineProperty(_FlippedPositions, Positions.RightCenter, Positions.LeftCenter), _defineProperty(_FlippedPositions, Positions.RightBottom, Positions.LeftBottom), _defineProperty(_FlippedPositions, Positions.LeftTop, Positions.RightTop), _defineProperty(_FlippedPositions, Positions.LeftCenter, Positions.RightCenter), _defineProperty(_FlippedPositions, Positions.LeftBottom, Positions.RightBottom), _FlippedPositions);
exports.FlippedPositions = FlippedPositions;
var DEFAULT_POSITION = Positions.RightCenter;
exports.DEFAULT_POSITION = DEFAULT_POSITION;